/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.PointRequest = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PointRequest model module.
   * @module model/PointRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>PointRequest</code>.
   * The request object for a point.
   * @alias module:model/PointRequest
   * @class
   * @param coord {String} The coordinate(latitude, longitude) of point.
   */
  var exports = function(coord) {
    var _this = this;

    _this['coord'] = coord;











  };

  /**
   * Constructs a <code>PointRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PointRequest} obj Optional instance to populate.
   * @return {module:model/PointRequest} The populated <code>PointRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('coord')) {
        obj['coord'] = ApiClient.convertToType(data['coord'], 'String');
      }
      if (data.hasOwnProperty('maxResults')) {
        obj['maxResults'] = ApiClient.convertToType(data['maxResults'], 'Number');
      }
      if (data.hasOwnProperty('placeCategories')) {
        obj['placeCategories'] = ApiClient.convertToType(data['placeCategories'], 'String');
      }
      if (data.hasOwnProperty('lang')) {
        obj['lang'] = ApiClient.convertToType(data['lang'], 'String');
      }
      if (data.hasOwnProperty('searchRadius')) {
        obj['searchRadius'] = ApiClient.convertToType(data['searchRadius'], 'Number');
      }
      if (data.hasOwnProperty('searchRadiusUnit')) {
        obj['searchRadiusUnit'] = ApiClient.convertToType(data['searchRadiusUnit'], 'String');
      }
      if (data.hasOwnProperty('srid')) {
        obj['srid'] = ApiClient.convertToType(data['srid'], 'Number');
      }
      if (data.hasOwnProperty('placeTypes')) {
        obj['placeTypes'] = ApiClient.convertToType(data['placeTypes'], 'String');
      }
      if (data.hasOwnProperty('verboseResults')) {
        obj['verboseResults'] = ApiClient.convertToType(data['verboseResults'], 'Boolean');
      }
      if (data.hasOwnProperty('reverseGeocodeTemplate')) {
        obj['reverseGeocodeTemplate'] = ApiClient.convertToType(data['reverseGeocodeTemplate'], 'String');
      }
      if (data.hasOwnProperty('includeIntersections')) {
        obj['includeIntersections'] = ApiClient.convertToType(data['includeIntersections'], 'Boolean');
      }
      if (data.hasOwnProperty('distanceUnit')) {
        obj['distanceUnit'] = ApiClient.convertToType(data['distanceUnit'], 'String');
      }
    }
    return obj;
  }

  /**
   * The coordinate(latitude, longitude) of point.
   * @member {String} coord
   */
  exports.prototype['coord'] = undefined;
  /**
   * Optional. The maximun length of the result returned.
   * @member {Number} maxResults
   */
  exports.prototype['maxResults'] = undefined;
  /**
   * Optional. The plcace categories to find nearby the point.
   * @member {String} placeCategories
   */
  exports.prototype['placeCategories'] = undefined;
  /**
   * The language of the result. The default value is \"en\".
   * @member {String} lang
   */
  exports.prototype['lang'] = undefined;
  /**
   * Optional. To find the places within the radius in meters.
   * @member {Number} searchRadius
   */
  exports.prototype['searchRadius'] = undefined;
  /**
   * The unit of measure in which the SearchRadius is expressed. Defaults to \"Meter\".
   * @member {module:model/PointRequest.SearchRadiusUnitEnum} searchRadiusUnit
   */
  exports.prototype['searchRadiusUnit'] = undefined;
  /**
   * Optional. The Srid for the result. The default value is 4326
   * @member {Number} srid
   */
  exports.prototype['srid'] = undefined;
  /**
   * Specified the types that should be included in the results.
   * @member {String} placeTypes
   */
  exports.prototype['placeTypes'] = undefined;
  /**
   * Indicates whether the results should be verbose or not. When false, the results will has fewer properties.
   * @member {Boolean} verboseResults
   */
  exports.prototype['verboseResults'] = undefined;
  /**
   * Specified how to format the result property.
   * @member {String} reverseGeocodeTemplate
   */
  exports.prototype['reverseGeocodeTemplate'] = undefined;
  /**
   * Indicates whether to include the interections in the result or not. Defaults to false.
   * @member {Boolean} includeIntersections
   */
  exports.prototype['includeIntersections'] = undefined;
  /**
   * The unit of measure in which the distance is expressed.
   * @member {module:model/PointRequest.DistanceUnitEnum} distanceUnit
   */
  exports.prototype['distanceUnit'] = undefined;


  /**
   * Allowed values for the <code>searchRadiusUnit</code> property.
   * @enum {String}
   * @readonly
   */
  exports.SearchRadiusUnitEnum = {
    /**
     * value: "Meter"
     * @const
     */
    "Meter": "Meter",
    /**
     * value: "Feet"
     * @const
     */
    "Feet": "Feet",
    /**
     * value: "Kilometer"
     * @const
     */
    "Kilometer": "Kilometer",
    /**
     * value: "Mile"
     * @const
     */
    "Mile": "Mile",
    /**
     * value: "UsSurveyFeet"
     * @const
     */
    "UsSurveyFeet": "UsSurveyFeet",
    /**
     * value: "Yard"
     * @const
     */
    "Yard": "Yard",
    /**
     * value: "NauticalMile"
     * @const
     */
    "NauticalMile": "NauticalMile",
    /**
     * value: "Inch"
     * @const
     */
    "Inch": "Inch",
    /**
     * value: "Link"
     * @const
     */
    "Link": "Link",
    /**
     * value: "Chain"
     * @const
     */
    "Chain": "Chain",
    /**
     * value: "Pole"
     * @const
     */
    "Pole": "Pole",
    /**
     * value: "Rod"
     * @const
     */
    "Rod": "Rod",
    /**
     * value: "Furlong"
     * @const
     */
    "Furlong": "Furlong",
    /**
     * value: "Vara"
     * @const
     */
    "Vara": "Vara",
    /**
     * value: "Arpent"
     * @const
     */
    "Arpent": "Arpent"  };

  /**
   * Allowed values for the <code>distanceUnit</code> property.
   * @enum {String}
   * @readonly
   */
  exports.DistanceUnitEnum = {
    /**
     * value: "Meter"
     * @const
     */
    "Meter": "Meter",
    /**
     * value: "Feet"
     * @const
     */
    "Feet": "Feet",
    /**
     * value: "Kilometer"
     * @const
     */
    "Kilometer": "Kilometer",
    /**
     * value: "Mile"
     * @const
     */
    "Mile": "Mile",
    /**
     * value: "UsSurveyFeet"
     * @const
     */
    "UsSurveyFeet": "UsSurveyFeet",
    /**
     * value: "Yard"
     * @const
     */
    "Yard": "Yard",
    /**
     * value: "NauticalMile"
     * @const
     */
    "NauticalMile": "NauticalMile",
    /**
     * value: "Inch"
     * @const
     */
    "Inch": "Inch",
    /**
     * value: "Link"
     * @const
     */
    "Link": "Link",
    /**
     * value: "Chain"
     * @const
     */
    "Chain": "Chain",
    /**
     * value: "Pole"
     * @const
     */
    "Pole": "Pole",
    /**
     * value: "Rod"
     * @const
     */
    "Rod": "Rod",
    /**
     * value: "Furlong"
     * @const
     */
    "Furlong": "Furlong",
    /**
     * value: "Vara"
     * @const
     */
    "Vara": "Vara",
    /**
     * value: "Arpent"
     * @const
     */
    "Arpent": "Arpent"  };


  return exports;
}));



